import { FormType, UserReplacementFieldNames } from "@/enums";
import { buildProjectStatusOptions } from "@/helpers";
import _ from "lodash";
import { useIntl } from "react-intl";

interface IObjectData {
  [key: string]: string;
}
const useMapGuidsToValues = (
  arrayOfObjectsData: IObjectData[],
  guidValues: string[],
  getPropertyValueDisplay: (
    formType: FormType,
    key: string,
    dataValue: string
  ) => string
): IObjectData[] => {
  const intl = useIntl();

  const dataMapped = arrayOfObjectsData.map((object) => {
    let mappedCols = {};
    const statuses = buildProjectStatusOptions();

    guidValues.forEach((key: string) => {
      let mappedVal = null;
      // statuses aren't pulled from forms, but rather hardcoded..
      if (key === UserReplacementFieldNames.ProjectStatus) {
        const statusId = object[_.camelCase(key)];
        const currentTranslationId = statuses.find(
          (x) => x.id === statusId
        )?.translationId;
        mappedVal = intl.formatMessage({ id: currentTranslationId });
      } else {
        mappedVal = getPropertyValueDisplay(
          FormType.Intake,
          _.camelCase(key),
          object[_.camelCase(key)]
        );
      }

      mappedCols = { ...mappedCols, [_.camelCase(key)]: mappedVal };
    });

    const mappedObject = { ...object, ...mappedCols };
    return mappedObject;
  });
  return dataMapped;
};

export default useMapGuidsToValues;
